// #region imports

// --- Angular
import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';

// #endregion

@Component({
  selector: 'hs-show-hide-more-text',
  templateUrl: './show-hide-more-text.component.html',
  styleUrls: ['./show-hide-more-text.component.scss'],
})
export class ShowHideMoreTextComponent
  implements OnInit, AfterViewInit, AfterViewChecked
{
  @Input() displayText: string = '';

  @ViewChild('showhide') showHideRef: ElementRef | undefined;
  @ViewChildren('showMore1, showMore2') showMoreRefs:
    | QueryList<any>
    | undefined;

  private changes: MutationObserver | undefined;
  private checkedSize = false;

  isExpanded: boolean;
  hasOverflow: boolean;
  showMoreText: string;

  constructor() {
    this.isExpanded = false;
    this.hasOverflow = true;
    this.showMoreText = 'jrnlShowMore';
  }

  ngOnInit() {
    const el = this.showHideRef?.nativeElement;

    this.changes = new MutationObserver((mutation: MutationRecord[]) => {
      mutation.forEach((mtn: MutationRecord) => this.elementChanged());
    });

    this.changes.observe(this.showHideRef?.nativeElement, {
      attributes: true,
      childList: true,
      characterData: true,
    });

    console.log(el.clientWidth);
    console.log(el.scrollWidth);
  }

  ngAfterViewInit(): void {}

  ngAfterViewChecked(): void {
    const el = this.showHideRef?.nativeElement;
    const curOverflow = el.style.overflowX;
    const x = 5;
  }

  onToggleMoreLess(): void {
    this.isExpanded = !this.isExpanded;
    this.showMoreText = this.isExpanded ? 'jrnlShowLess' : 'jrnlShowMore';
  }

  elementChanged(): void {
    if (this.checkedSize || this.isExpanded) {
      return;
    }

    const el = this.showHideRef?.nativeElement;
    if (el.clientHeight === 0) {
      return;
    }

    const hasOverflow =
      el.clientHeight + 5 < el.scrollHeight || el.clientWidth < el.scrollWidth;

    const display = hasOverflow ? '' : 'none';

    this.showMoreRefs?.forEach((anchor) => {
      anchor.nativeElement.style.display = display;
    });

    this.checkedSize = true;
  }
}
